export default __webpack_public_path__ + "static/media/image2.ec6c5f52.webp";